import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FolderLimitedSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FolderLimitedSVG;
